<template>
  <div id="mypage-community-form-template">
    <h2 class="show-title">글쓰기</h2>
    <div class="basic-form">
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">제목</label>
        <input type="text" v-model="title" name="" class="input__text" placeholder="입력해주세요." title="입력해주세요.">
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">요약</label>
        <textarea class="input__textarea input__textarea--thin" v-model="excerpt" rows="2" title="결과 입력"></textarea>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">썸네일</label>
        <input type="file" id="thumbnail" v-on:change="imageUpload('thumbnail')" class="inline-input__file" title="thumbnail 첨부파일 선택">
        <img :src="imgUrl" class="thumbnail-img-ex" alt="썸네일이미지">
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">내용</label>
        <ckeditor name="description" v-model="content" :config="fiftyplusExcerpt" ></ckeditor>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">태그</label>
        <input type="text" v-model="tags" class="input__text" placeholder="입력해주세요." title="입력해주세요.">
        <p class="helper-text">ex) #여행 #집 #배움</p>
      </div>

      <div class="text-center">
        <button type="button" class="form-submit__btn btn--blue-line" @click="save">글 쓰기</button>
      </div>
    </div>
  </div>
</template>
<script>
  /* global CKEDITOR */
  import Axios from 'axios';
  import Ckeditor from 'vue-ckeditor2';
  import CommonFn from '../../common-functions/commonFuntions';

  const commonFn = new CommonFn();

  export default {
    name: 'mypage-community-form-template',
    props: ['post'],
    components: {
      Ckeditor,
    },
    data() {
      return {
        fiftyplusExcerpt: {
          height: 450,
          contentsCss: '/css/editor.css',
          font_defaultLabel: 'Spoqa Han Sans',
          toolbar: [
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting', 'RemoveFormat'] },
            { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            { name: 'links', items: ['Link', 'Unlink'] },
            { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          ],
          filebrowserImageUploadUrl: '/api/file-uploads/ckeditorImageUpload.do',
          font_names: `돋움; 굴림; 맑은 고딕; 바탕; 궁서; ${CKEDITOR.config.font_names}`,
        },
        content: '',
        excerpt: '',
        title: '',
        tags: '',
        url: '/api/member-posts/community',
        communityId: '',
        imgUrl: '',
        id: '',
      };
    },
    watch: {
    },
    methods: {
      imageUpload(id) {
        const formData = new FormData();
        const fileSize = document.getElementById(`${id}`).files[0].size;
        if (((fileSize / 1024) / 1024).toFixed(4) > 2) {
          alert('이미지파일은 최대 2MB 사이즈 까지만 업로드가 가능합니다.');
          document.getElementById(`${id}`).value = '';
        } else {
          formData.append('file', document.getElementById(`${id}`).files[0]);
          const Config = {
            /* eslint-disable */
            headers: {
              'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
            },
            /* eslint-enable */
          };
          Axios.post('/api/file-uploads', formData, Config).then((res) => {
            this.imgUrl = res.data.filename;
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      save() {
        let tagList = null;
        if (this.tags) {
          this.tags = this.tags.replace('/#/gi', '');
          tagList = this.tags.split(' ');
        }
        const Params = {
          title: this.title,
          excerpt: this.excerpt,
          imageUrl: this.imgUrl,
          content: this.content,
          tags: tagList,
        };
        if (!this.post) {
          Axios.post(`${this.url}/${this.communityId}`, Params).then((res) => {
            alert('등록되었습니다.');
            location.href = `/mypage-community-detail.do?id=${this.communityId}&postId=${res.data}`;
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        } else {
          Axios.put(`${this.url}/${this.communityId}/${this.id}`, Params).then((res) => {
            alert('저장되었습니다.');
            location.href = `/mypage-community-detail.do?id=${this.communityId}&postId=${res.data.id}`;
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      getParams() {
        const url = window.location.search.substring(1);
        this.communityId = commonFn.parseQueryString(url).id;
      },
    },
    mounted() {
      this.getParams();
      if (this.post) {
        this.id = this.post.id;
        this.title = this.post.title;
        this.content = this.post.content;
        this.imgUrl = this.post.imageUrl;
        this.excerpt = this.post.excerpt;
        if (this.post.tags) {
          this.post.tags.forEach((item) => {
            this.tags += `#${item} `;
          });
        }
      }
    },
  };
</script>


// WEBPACK FOOTER //
// CommunityForm.vue?18a6dcfe